import { Route } from '@angular/router';

import { Scopes } from '@ninety/platform/models/entitlements/entitlements-model';

import { DefaultTieredPageComponent } from './components/_default-tiered-page/default-tiered-page.component';
import { HeadlinesTieredPageComponent } from './components/headlines-tiered-page/headlines-tiered-page';
import { InsightsTieredPageComponent } from './components/insights-tiered-page/insights-tiered-page.component';
import { IssuesTieredPageComponent } from './components/issues-tiered-page/issues-tiered-page.component';
import { MeetingsTieredPageComponent } from './components/meetings-tiered-page/meetings-tiered-page.component';
import { MyNinetyTieredPageComponent } from './components/my-ninety-tiered-page/my-ninety-tiered-page.component';
import { OneOnOneTieredPageComponent } from './components/one-on-one-tiered-page/one-on-one-tiered-page.component';
import { RocksTieredPageComponent } from './components/rocks-tiered-page/rocks-tiered-page.component';
import { ScorecardTieredPageComponent } from './components/scorecard-tiered-page/scorecard-tiered-page.component';
import { TodosTieredPageComponent } from './components/todos-tiered-page/todos-tiered-page.component';

export const COMMERCIAL_MODEL_ROUTES: Route[] = [
  /** default tiered pages (no access on current tier) */
  {
    path: 'no-access',
    children: [
      {
        path: Scopes.issues,
        component: IssuesTieredPageComponent,
        data: { route: 'issue' },
      },
      {
        path: Scopes.rocks,
        component: RocksTieredPageComponent,
        data: { route: 'rock' },
      },
      {
        path: Scopes.todos,
        component: TodosTieredPageComponent,
        data: { route: 'todo' },
      },
      {
        path: Scopes.insights,
        component: InsightsTieredPageComponent,
        data: { title: 'Insights' },
      },
      { path: Scopes.weeklyMeetings, component: MeetingsTieredPageComponent, data: { title: 'Meetings' } },
      {
        path: Scopes.headlines,
        component: HeadlinesTieredPageComponent,
        data: { title: 'Headlines' },
      },
      {
        path: Scopes.scorecard,
        component: ScorecardTieredPageComponent,
        data: { route: 'scorecard' },
      },
      { path: Scopes.my90, component: MyNinetyTieredPageComponent, data: { title: 'My 90' } },
      {
        path: Scopes.oneOnOne,
        component: OneOnOneTieredPageComponent,
        data: { title: '1-on-1 Discussions' },
      },
      {
        path: ':feature',
        component: DefaultTieredPageComponent,
        data: { title: 'No Access' },
      },
      { path: '', component: DefaultTieredPageComponent, data: { title: 'No Access' } },
      { path: '**', redirectTo: '', pathMatch: 'full' },
    ],
  },
];
